let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8TwED")).then(() => parcelRequire('2ZSJh'));